import { createFileRoute } from '@tanstack/react-router'
import NewConceptTeam from 'Concept/components/Concept/Sections/ConceptTeam/NewConceptTeam'

export const Route = createFileRoute('/concept/$conceptId/members')({
    component: NewConceptTeam,
})
